import { useState } from 'react';
import { getAddressDataOptions, getFullAddressData } from '../apiCalls';
import { markJourneyInteraction, noteJourneyField } from '../utils/journey';

export const mapApiAddressToForm = (apiAddress = {}, postCode = '') => ({
    postCode,
    address1: apiAddress.line_1 || '',
    address2: apiAddress.post_town || '',
    address3: apiAddress.county || '',
});

export const useAddressLookup = (postCode) => {
    const [addressOptions, setAddressOptions] = useState([]);
    const [isLookingUp, setIsLookingUp] = useState(false);
    const [isFetchingAddress, setIsFetchingAddress] = useState(false);
    const [error, setError] = useState(null);

    const lookupAddresses = async () => {
        if (!postCode) return;
        markJourneyInteraction();
        noteJourneyField('addressLookup');
        setIsLookingUp(true);
        setError(null);
        setAddressOptions([]);

        try {
            const response = await getAddressDataOptions(postCode);
            const suggestions = response.data?.suggestions || [];

            if (suggestions.length > 0) {
                setAddressOptions(suggestions);
            } else {
                setError('No addresses found for this postcode. Please enter your address manually.');
            }
        } catch (err) {
            setError(err.friendlyMessage || 'Error fetching address. Please enter your address manually.');
        } finally {
            setIsLookingUp(false);
        }
    };

    const fetchAddress = async (id) => {
        if (!id) return null;
        markJourneyInteraction();
        noteJourneyField('addressSelect');
        setIsFetchingAddress(true);
        setError(null);

        try {
            const response = await getFullAddressData(id);
            setAddressOptions([]);
            return mapApiAddressToForm(response.data.address, postCode);
        } catch (err) {
            setError(err.friendlyMessage || 'Could not load the selected address. Please enter your address manually.');
            return null;
        } finally {
            setIsFetchingAddress(false);
        }
    };

    return {
        addressOptions,
        isLoading: isLookingUp || isFetchingAddress,
        isLookingUp,
        isFetchingAddress,
        error,
        lookupAddresses,
        fetchAddress,
    };
};
